import AbstractComponent from "../core/abstract-component";
import InstanceManager from "../utilities/instance-manager";

const instanceManager = new InstanceManager();

export default class BaseComponent extends AbstractComponent {
    protected element: HTMLElement;
    protected config?: { [key: string]: any };

    constructor(element: HTMLElement | null = null, config?: { [key: string]: any }) {
        super();
        this.element = element!;
        this.config = config;
    }

    public init() {}
    public process() {}

    public static getInstance<T extends BaseComponent>(element: HTMLElement): T | null {
        return instanceManager.get<T>(element, this.name);
    }

    public static createInstance<T>(element: HTMLElement, config?: { [key: string]: any }): T {
        return new this(element, config) as T;
    }

    public static getOrCreateInstance<T extends BaseComponent>(element: HTMLElement, config?: { [key: string]: any }, init?: boolean): T {
        if(this.getInstance(element) == null) {
            const instance: T = this.createInstance(element, config);
            element.getInstanceForComponent = (componentName: string): AbstractComponent|null => {
                componentName = (componentName && componentName != '') ? componentName : this.name;
                return instanceManager.get(element, componentName);
            };
            instanceManager.set<T>(element, this.name, instance);
            if(
                typeof instance.init === "function"
                && ( typeof(init) == 'undefined' || init == true )
            ) {
                instance.init();
            }
        }
        return this.getInstance<T>(element)!;
    }

    public static initializeDom(selector: string = '', onDomContentLoaded: boolean = false, onWindowLoad: boolean = false, observe: boolean = false) {
        const self = this;
        const processInitialization = function(selector: string) {
            self.initializeElements(selector);
            if(observe) {
                const observer = new MutationObserver((mutationList: MutationRecord[], observer: MutationObserver) => {
                    self.initializeElements(selector);
                });
                observer.observe(document.body, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
            }
        };

        if(onDomContentLoaded) {
            if(document.readyState === 'complete') {
                processInitialization(selector);
            } else {
                document.addEventListener('DOMContentLoaded', () => {
                    processInitialization(selector);
                });
            }
        } else if(onWindowLoad) {
            window.addEventListener('load', () => {
                processInitialization(selector);
            });
        } else {
            processInitialization(selector);
        }
    }

    protected static initializeElements(selector: string = '') {
        if(selector != '') {
            document.querySelectorAll<HTMLElement>(selector)?.forEach((el: HTMLElement) => {
                if(this.getInstance(el) == null) {
                    let config:{[key: string]: any} = {};
                    try {
                        const configAttributeValue: string = el.dataset.config ?? el.dataset.thConfig  ?? el.dataset.bsConfig ?? '';
                        let configAttribute:{[key: string]: any} = {};
                        if(configAttributeValue && configAttributeValue != '') {
                            configAttribute = JSON.parse(configAttributeValue);
                        }
                        config = configAttribute;
                        for(const k in el.dataset) {
                            if(k == 'bsConfig' || k == 'tmtConfig' || k == 'config') {
                                continue;
                            }
                            if(k.substring(0, 2) == 'bs' || k.substring(0,3) == 'tmt') {
                                const key = k[2].toLowerCase()+k.substring(3);
                                config[key] = (configAttribute[key]) ? configAttribute[key] : el.dataset[k];
                            }
                        }
                    } catch (ex) {

                    }
                    const instance = this.getOrCreateInstance(el, config);
                    if(typeof instance.process === "function") {
                        instance.process();
                    }
                }
            });
        }
    }
}
